import {NodeContentRenderer} from './NodeContentRenderer';
import {TreeNodeRenderer} from './TreeNodeRenderer';
export default {
	nodeContentRenderer: NodeContentRenderer,
	treeNodeRenderer: TreeNodeRenderer,
	scaffoldBlockPxWidth: 24,
	slideRegionSize: 50,
	rowHeight: 48,
};
